<div class="mb-5 sm:pl-6 sm:mb-0">
	<h1 class="text-2xl font-bold tracking-tight text-black sm:text-2xl">
		{{ name() }}
	</h1>
	<div class="flex flex-wrap">
		<p class="mr-1 text-gray-500">
			@if (recommendedPercentage()) {
				{{ recommendedPercentage() }}% Recommended •
			} @else {
				<uc-write-review-btn
					[universityId]="uniId()"
					[universityName]="name()"
					[universityUrl]="slug()"
					buttonText="Leave a review"
				/>
			}
		</p>
		<a
			class="text-base cursor-pointer blue-link-underline"
			[routerLink]="[
				'/courses',
				redirectTo.navigate(paidFeatures(), subdirectory(), product()),
			]"
			[queryParams]="{ uni: slug() }"
		>
			<span class="hidden sm:inline">See all&nbsp;</span>
			<span class="hidden capitalize sm:inline">{{ product() }}</span>
			<span class="capitalize sm:hidden">
				{{
					product() === 'postgraduate'
						? 'All Postgrad'
						: product() === 'clearing'
							? 'All Clearing'
							: 'All Undergrad'
				}}
			</span>
			Courses
		</a>
	</div>
</div>
